var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5271,
    cy: 75.8679,
    r: 73.0587,
    fill: "#0C0A0A",
    stroke: "black",
    strokeWidth: 4.9372
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_17421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.314 59.3755L77.8165 110.327L41.9096 56.7352C41.9096 56.7352 63.089 41.6836 79.713 42.1125C96.6192 42.5487 117.314 59.3755 117.314 59.3755Z",
    stroke: "white",
    strokeWidth: 0.801679,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8169 110.327L42.0508 36.6931L50.2666 36.5413L77.8169 110.327Z",
    fill: "#FBBA22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8169 110.327L50.2666 36.541L55.9809 31.2234L77.8169 110.327Z",
    fill: "#E8AF26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8165 110.327L55.9805 31.2234L63.6275 32.8861L77.8165 110.327Z",
    fill: "#F35208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8159 110.326L63.6289 32.8859L70.765 28.5444L77.8159 110.326Z",
    fill: "#DF410D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8166 110.326L70.7657 28.5444L78.8437 31.8028L77.8166 110.326Z",
    fill: "#F5056C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8165 110.326L78.84 31.6028L86.1988 28.46L77.8165 110.326Z",
    fill: "#DB0E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8165 110.326L86.1988 28.46L93.1006 33.1433L77.8165 110.326Z",
    fill: "#7B49E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8165 110.326L93.1006 33.1434L100.489 31.6035L77.8165 110.326Z",
    fill: "#673CCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8165 110.326L100.489 31.6035L106.207 37.311L77.8165 110.326Z",
    fill: "#3C8CFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8165 110.327L106.207 37.3112L114.423 37.1597L77.8165 110.327Z",
    fill: "#337FE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1721 115.713L70.2763 119.303L63.454 122.894C63.454 122.894 68.4809 119.565 68.4809 119.303C68.4809 119.042 64.1721 115.713 64.1721 115.713Z",
    fill: "#BA2F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4615 115.713L85.3574 119.303L92.1797 122.894C92.1797 122.894 87.1527 119.565 87.1527 119.303C87.1527 119.042 91.4615 115.713 91.4615 115.713Z",
    fill: "#BA2F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4074 131.062L77.8167 124.958L74.226 131.78C74.226 131.78 77.555 126.753 77.8167 126.753C78.0785 126.753 81.4074 131.062 81.4074 131.062Z",
    fill: "#BA2F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8336 122.928C79.826 122.928 81.4412 121.313 81.4412 119.32C81.4412 117.328 79.826 115.713 77.8336 115.713C75.8412 115.713 74.226 117.328 74.226 119.32C74.226 121.313 75.8412 122.928 77.8336 122.928Z",
    fill: "#BFD3EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_17421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.9952,
    height: 104.13,
    fill: "white",
    transform: "translate(40.1145 27.7407)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logo-circle.017b1981b2add841040c41d040e21ff2.svg";
export { ForwardRef as ReactComponent };